//  React TS Base Styles
import colors from '../../base/colors'
import typography from '../../base/typography'

//  React TS Helper Functions
import pxToRem from '../../functions/pxToRem'

const { transparent, light, info, secondary } = colors
const { size } = typography

const outlined = {
  base: {
    // The secondary pill: a translucent lift of the page, never an outline.
    minHeight: pxToRem(40),
    color: light.main,
    borderColor: 'transparent',
    backgroundColor: 'var(--dewi_pill_secondary)',
    padding: `${pxToRem(10)} ${pxToRem(24)}`,

    '&:hover': {
      opacity: 0.75,
      border: 'none',
      borderColor: 'transparent',
      backgroundColor: 'var(--dewi_pill_secondary_hover)',
    },

    '&.Mui-disabled': {
      border: 'none',
      borderColor: 'transparent',
    },

    '& .material-icon, .material-icons-round, svg': {
      fontSize: `${pxToRem(16)}`,
    },
  },

  small: {
    minHeight: pxToRem(32),
    padding: `${pxToRem(6)} ${pxToRem(16)}`,
    fontSize: size.xs,

    '& .material-icon, .material-icons-round, svg': {
      fontSize: `${pxToRem(12)}`,
    },
  },

  large: {
    minHeight: pxToRem(47),
    padding: `${pxToRem(12)} ${pxToRem(28)}`,
    fontSize: size.sm,

    '& .material-icon, .material-icons-round, svg': {
      fontSize: `${pxToRem(22)}`,
    },
  },

  primary: {
    backgroundColor: transparent.main,
    borderColor: info.main,

    '&:hover': {
      backgroundColor: transparent.main,
    },
  },

  secondary: {
    backgroundColor: transparent.main,
    borderColor: secondary.main,

    '&:hover': {
      backgroundColor: transparent.main,
    },
  },
}

export default outlined
